module.exports = __webpack_public_path__ + "img/botao-editar.9b987d11.png";